'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Confirmation = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _createGoogleCalendarEventLink = require('helpers/createGoogleCalendarEventLink');

var _createGoogleCalendarEventLink2 = _interopRequireDefault(_createGoogleCalendarEventLink);

var _tzOffsets = require('tz-offsets');

var _tzOffsets2 = _interopRequireDefault(_tzOffsets);

var _RecommendedVenuesContainer = require('./RecommendedVenuesContainer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Confirmation = exports.Confirmation = function Confirmation(_ref) {
  var address = _ref.address,
      description = _ref.description,
      endTime = _ref.endTime,
      klass = _ref.klass,
      location = _ref.location,
      onModalClose = _ref.onModalClose,
      startTime = _ref.startTime,
      timeZone = _ref.timeZone,
      venueName = _ref.venueName,
      venueId = _ref.venueId;
  return _react2.default.createElement(
    'div',
    { className: 'reservation' },
    _react2.default.createElement(
      'div',
      { className: 'reservation__header' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.confirmation',
        defaultMessage: 'Reservation Confirmed'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'reservation__class-name mb' },
      klass
    ),
    _react2.default.createElement(
      'div',
      { className: 'reservation__venue' },
      venueName + ' - ' + location
    ),
    _react2.default.createElement(
      'div',
      { className: 'reservation__date mt+ text--xl' },
      _react2.default.createElement(_reactIntl.FormattedDate, {
        value: (0, _tzOffsets2.default)(startTime, timeZone) * 1000,
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'reservation__time mb text--xl' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.confirmation.class.time',
        defaultMessage: '{start} - {end}',
        values: {
          start: _react2.default.createElement(_reactIntl.FormattedTime, {
            value: (0, _tzOffsets2.default)(startTime, timeZone) * 1000,
            hour: 'numeric',
            minute: 'numeric'
          }),
          end: _react2.default.createElement(_reactIntl.FormattedTime, {
            value: (0, _tzOffsets2.default)(endTime, timeZone) * 1000,
            hour: 'numeric',
            minute: 'numeric'
          })
        }
      })
    ),
    _react2.default.createElement(
      'a',
      { className: 'reservation__add-to-calendar mv', href: (0, _createGoogleCalendarEventLink2.default)(klass, description, address, startTime, endTime) },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.confirmation.add-to-calendar',
        defaultMessage: 'Add to Google Calendar'
      })
    ),
    _react2.default.createElement(
      'button',
      {
        className: 'bt bt--primary bt--lg mb+',
        onClick: onModalClose
      },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.confirmation.done',
        defaultMessage: 'Done'
      })
    ),
    _react2.default.createElement(_RecommendedVenuesContainer.RecommendedVenuesContainer, { venueId: venueId, venue: venueName })
  );
};

Confirmation.propTypes = {
  address: _propTypes2.default.shape({
    address_line1: _propTypes2.default.string,
    city: _propTypes2.default.string,
    state: _propTypes2.default.string,
    zip_code: _propTypes2.default.string
  }),
  description: _propTypes2.default.string,
  endTime: _propTypes2.default.number,
  klass: _propTypes2.default.string,
  location: _propTypes2.default.string,
  onModalClose: _propTypes2.default.func.isRequired,
  startTime: _propTypes2.default.number,
  timeZone: _propTypes2.default.string,
  venueName: _propTypes2.default.string,
  venueId: _propTypes2.default.number
};